import { render, staticRenderFns } from "./NewsList.vue?vue&type=template&id=f7439750&"
import script from "./NewsList.vue?vue&type=script&lang=ts&"
export * from "./NewsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports